import { createEffect, ofType, Actions } from '@ngrx/effects';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Store, Action } from '@ngrx/store';
import { LayoutActionTypes, AllTilesRequested, AllTilesLoaded } from '../actions/layout.actions';
import { Injectable } from '@angular/core';
import { LayoutService } from 'src/app/core/services/layout.service';
import { LayoutState } from '../reducers/layout.reducer';

@Injectable()
export class LayoutEffects {

  loadAllTiles$: Observable<Action> = createEffect(() => this.actions$
    .pipe(
      ofType(LayoutActionTypes.AllTilesRequested),

      switchMap((action: any) => this.layoutService.getTiles()),
      map((data: any) => AllTilesLoaded({ tiles: data }))
    ));


/*


 combineLatest(
              this.store.select(getUsersByIds(userIds)),
              this.store.select(getGroupsByIds(groupIds))
            ).subscribe(([users, groups]) => {
              this.setSelectedUsers(users);
              this.setSelectedGroups(groups);
            });
            */

 /*  loadMovies$ = createEffect(() => this.actions$.pipe(
    ofType('[Movies Page] Load Movies'),
    mergeMap(() => this.moviesService.getAll()
      .pipe(
        map(movies => ({ type: '[Movies API] Movies Loaded Success', payload: movies })),
        catchError(() => EMPTY)
      ))
    )
  ); */
  constructor(private actions$: Actions, private layoutService: LayoutService,
    private store: Store<LayoutState>) {

  }
}
